export default {
	create: {
		formLabel: {
			staffId: 'Staff ID',
			provider: 'Provider',
			group: 'Group',
			username: 'Username',
			password: 'Password',
			firstName: 'First name',
			lastName: 'Last name',
			status: 'Status',
			userGroup: 'User group',
			email: 'Email address',
			phone: 'Phone',
			storeId: 'Store ID',
			store: 'Store name',
			note: 'Note',
		},
		value: {
			status: {
				active: 'Active',
				inactive: 'Inactive',
			},
		},
		button: {
			submit: 'Create',
			cancel: 'Cancel',
		},
		description: {
			username: 'Allow letters (a-z), numbers, and ( - ), ( _ )',
			password: 'Minimum 8 characters',
		},
		validationMessage: {
			username: {
				required: 'Required field',
				exists: 'Username already exists',
				lengthLimit: 'Field Length: 4 - 255 characters',
				alphanumberic: 'Allow letters (a-z), numbers, and ( - ), ( _ )',
			},
			password: {
				required: 'Required field',
				lengthLimit: 'Field Length: 8 - 255 characters',
				notSameOldPassword: 'It seems you have entered same password as old password',
			},
			email: {
				exists: 'Email already exists',
				lengthLimit: 'Field Length: Maximum 255 characters',
				invalidFormat: 'Invalid email',
			},
			firstName: {
				required: 'Required field',
				lengthLimit: 'Field Length: 1 - 35 characters',
			},
			lastName: {
				lengthLimit: 'Field Length: 0 - 35 characters',
			},
			store: {
				lengthLimit: 'Field Length: 0 - 50 characters',
			},
			storeId: {
				lengthLimit: 'Field Length: 0 - 255 characters',
			},
			phone: {
				lengthLimit: 'Field Length: 0 - 255 characters',
			},
			note: {
				lengthLimit: 'Field Length: 0 - 150 characters',
			},

		},
		successMessageTitle: 'Success',
		successMessage: 'New user has been created.',
		errorMessageTitle: 'Unable to save',
		errorMessage: 'An unexpected error occurred. Please try again.',
	},
};
